export default "__VITE_ASSET__COmkWFcY__"